import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/TeamRegistrationConfig/Get', params)
    },
    getList: params => {
        return API.GET('/api/TeamRegistrationConfig/List', params)
    },
    add: params => {
        return API.POST('/api/TeamRegistrationConfig/Add', params)
    },
    edit: params => {
        return API.POST('/api/TeamRegistrationConfig/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/TeamRegistrationConfig/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/TeamRegistrationConfig/DeleteBatch', params)
    },
    select:params=>{
        return API.GET('/api/TeamRegistrationConfig/Select', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/teamregistrationconfig.js